//
//
//
//
import MemberLogin from '~/components/auth/member-login.vue';
import { generateMetaHead } from '~/utils/meta';
export default {
  components: {
    MemberLogin
  },
  layout: 'password',

  head() {
    return { ...generateMetaHead({
        title: 'Login Members Area | Extra',
        description: 'Login to our Members Area to set up your Extra Card.'
      })
    };
  }

};